if (!customElements.get('as-pedal-offer')) {
  customElements.define('as-pedal-offer', class extends HTMLElement {
    static shown = false;
    connectedCallback() {
      let handled = this.constructor.shown;
      try { handled ||= sessionStorage.getItem('as-pedal-offer-v1') === '1'; } catch {}
      if (handled) return;
      this.hidden = false;
      this.observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.constructor.shown = true;
        try { sessionStorage.setItem('as-pedal-offer-v1', '1'); } catch {}
        this.observer.disconnect();
      });
      this.observer.observe(this);
      this.querySelector('[data-offer-decline]')?.addEventListener('click', () => {
        this.constructor.shown = true;
        try { sessionStorage.setItem('as-pedal-offer-v1', '1'); } catch {}
        this.hidden = true;
      });
      this.querySelector('form')?.addEventListener('submit', () => {
        this.querySelector('button[type="submit"]').disabled = true;
      });
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  });
}
